import { Link } from "react-router-dom";
import { CLINIC } from "@/lib/brand";

export default function MarketingFooter() {
  return (
    <footer className="border-t border-[color:var(--border)] bg-white mt-20" data-testid="marketing-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <img src={CLINIC.logoUrl} alt={CLINIC.name} className="w-10 h-10 rounded-full object-cover" />
            <span className="font-heading text-[14px] font-medium leading-tight">{CLINIC.shortName}<br /><span className="text-[10px] text-[color:var(--muted)] tracking-[0.18em] uppercase font-normal">Homoeopathy</span></span>
          </div>
          <p className="text-sm text-[color:var(--muted)] leading-relaxed italic">"{CLINIC.tagline}"</p>
          <p className="text-sm text-[color:var(--muted)] leading-relaxed mt-3">Classical homeopathic care for modern life. {CLINIC.city}, {CLINIC.country}.</p>
        </div>
        <div>
          <p className="text-xs font-semibold tracking-[0.18em] uppercase text-[color:var(--muted)] mb-3">Explore</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="text-[color:var(--ink)] hover:text-[color:var(--primary)]">About the doctor</Link></li>
            <li><Link to="/conditions" className="text-[color:var(--ink)] hover:text-[color:var(--primary)]">Conditions treated</Link></li>
            <li><Link to="/blog" className="text-[color:var(--ink)] hover:text-[color:var(--primary)]">Journal</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-semibold tracking-[0.18em] uppercase text-[color:var(--muted)] mb-3">Patient</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/book" className="text-[color:var(--ink)] hover:text-[color:var(--primary)]">Book appointment</Link></li>
            <li><Link to="/login" className="text-[color:var(--ink)] hover:text-[color:var(--primary)]">Patient login</Link></li>
            <li><Link to="/contact" className="text-[color:var(--ink)] hover:text-[color:var(--primary)]">Contact us</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-semibold tracking-[0.18em] uppercase text-[color:var(--muted)] mb-3">Contact</p>
          <ul className="space-y-2 text-sm text-[color:var(--muted)]">
            <li>{CLINIC.address}</li>
            <li>{CLINIC.phone}</li>
            <li>{CLINIC.email}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[color:var(--border)] py-4 text-center text-xs text-[color:var(--muted)]">
        © {new Date().getFullYear()} {CLINIC.name}. All rights reserved.
      </div>
    </footer>
  );
}
